import React, { useState, useEffect } from 'react';
import Steps from './steps';
import FormikWizard from 'formik-wizard';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import useWindowResize from '../../hooks/useWindowResize';
import finictyLogo from '../../images/logo-192.png';
import CircularLoading from '../../common/components/CircularLoading/CircularLoading';
function FormWrapper({ children, canGoBack, wizard, steps }) {
  const [windowWidth, windowHeight] = useWindowResize();
  const [updatingChange, setUpdatingChange] = useState(false);

  const handleGoBack = () => {
    if (!canGoBack) return;
    let currStepIndex = wizard.steps.indexOf(wizard.step);
    wizard.push(steps[currStepIndex - 1]);
  };

  return (
    <div className=" w-full  md:min-h-full max-h-full   md:h-screen  overflow-auto scrolling-auto bg-navy-600 relative py-2 ">
      <div
        className=" w-full max-w-sm md:max-w-md mx-auto py-5 min-h-full  bg-white  "
        style={{
          ...(windowWidth > 767
            ? {
                height: 'min-content',
                marginTop: '100px',
                minHeight: 'auto'
              }
            : {
                minHeight: '100vh'
              })
        }}
      >
        <div className="relative  flex flex-row items-center h-auto md:h-auto  max-h-full justify-center space-x-3 max-w-full p-2 ">
          <div className="flex flex-col place-self-start content-center w-full h-full md:h-auto px-4">
            <div className="flex  items-center justify-center">
              {canGoBack &&
                wizard?.step?.id !== 'bPVerified' &&
                wizard?.step?.id !== 'bPVerificationPending' &&
                wizard?.step?.id !== 'bPRejected' && (
                  <KeyboardBackspaceIcon
                    className="block mt-2 cursor-pointer "
                    onClick={handleGoBack}
                    color={canGoBack ? 'action' : 'disabled'}
                    style={{ fontSize: 36 }}
                  />
                )}

              <img
                className="block mx-auto  w-16 "
                src={finictyLogo}
                alt="Fincity Business Partner"
              />
            </div>
            <div
              className="font-bold text-base xxs:text-lg md:text-xl mt-4 mb-2 mx-auto text-center max-w-full"
              style={{
                color: '#394759'
              }}
            >
              Business Partner Onboarding
            </div>
            {updatingChange ? <CircularLoading /> : children}
          </div>
        </div>
      </div>
    </div>
  );
}
const Index = () => {
  const handleSubmit = React.useCallback(values => {}, []);

  return (
    <FormikWizard steps={Steps} onSubmit={handleSubmit} render={FormWrapper} />
  );
};
export default withErrorHandler(Index);
